import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { UserRoleInterface } from '../../../interfaces/interfaces';

export const getUserRoleTableColumns = (
  setRoleToDelete: (role: UserRoleInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setRoleToToggleActive: (role: UserRoleInterface) => void,
  setToggleActiveDialogOpen: (open: boolean) => void,
  setRoleToUpdate: (role: UserRoleInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void  
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'roleName', headerName: 'Role Name', width: 180 },
  { field: 'description', headerName: 'Description', width: 250 },
  { field: 'active', headerName: 'Active', width: 100, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 180 },
  { field: 'updated_at', headerName: 'Updated', width: 180 },
  {
    field: 'toggleActive',
    headerName: 'Toggle Active',
    width: 130,
    renderCell: (params) => (
      <Button
        color={params.row.active ? 'warning' : 'success'}
        variant="outlined"
        size="small"
        onClick={() => {
          setRoleToToggleActive(params.row);
          setToggleActiveDialogOpen(true);
        }}
      >
        {params.row.active ? 'Deactivate' : 'Activate'}
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setRoleToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    flex: 1,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setRoleToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  }  
];